import reactor from 'data/reactor';

const ADVANCE_TO_ADJACENT_STUDENT = 'ADVANCE_TO_ADJACENT_STUDENT';
const ALLOW_ADVANCE_STUDENT = 'ALLOW_ADVANCE_STUDENT';
const CHANGE_SELECTED_SUBJECT = 'CHANGE_SELECTED_SUBJECT';
const CLEAR_STATE = 'CLEAR_STATE';
const CLOSE_GRADE_DROPDOWN = 'CLOSE_GRADE_DROPDOWN';
const COMPLETE_TRANSITION = 'COMPLETE_TRANSITION';
const EXPAND_MODULE = 'EXPAND_MODULE';
const INITIAL_LOAD_DONE = 'INITIAL_LOAD_DONE';
const REGISTER_MODAL = 'REGISTER_MODAL';
const RESET_DISPLAY_SETTINGS = 'RESET_DISPLAY_SETTINGS';
const SELECT_COMPARISON_PERIOD = 'SELECT_COMPARISON_PERIOD';
const SELECT_INSTRUCTIONAL_AREAS = 'SELECT_INSTRUCTIONAL_AREAS';
const SET_ANIMATION_IS_RUNNING = 'SET_ANIMATION_IS_RUNNING';
const SET_PAGE_ALERT = 'SET_PAGE_ALERT';
const SET_STUDENT_TRANSITION = 'SET_STUDENT_TRANSITION';
const SET_UNSAVED_DATA = 'SET_UNSAVED_DATA';
const SET_USER_ACTION = 'SET_USER_ACTION';
const SINGLE_STUDENT_SEARCH_RENDERING = 'SINGLE_STUDENT_SEARCH_RENDERING';
const TOGGLE_HELPBOX_POPOVER = 'TOGGLE_HELPBOX_POPOVER';
const TOGGLE_MODAL_DIALOG = 'TOGGLE_MODAL_DIALOG';
const TOGGLE_STUDENT_LIST_POPOVER = 'TOGGLE_STUDENT_LIST_POPOVER';
const TOGGLE_HIGHLIGHTS = 'TOGGLE_HIGHLIGHTS';

export default {
    ADVANCE_TO_ADJACENT_STUDENT,
    ALLOW_ADVANCE_STUDENT,
    CHANGE_SELECTED_SUBJECT,
    CLEAR_STATE,
    CLOSE_GRADE_DROPDOWN,
    COMPLETE_TRANSITION,
    EXPAND_MODULE,
    INITIAL_LOAD_DONE,
    REGISTER_MODAL,
    RESET_DISPLAY_SETTINGS,
    SELECT_COMPARISON_PERIOD,
    SELECT_INSTRUCTIONAL_AREAS,
    SET_ANIMATION_IS_RUNNING,
    SET_PAGE_ALERT,
    SET_STUDENT_TRANSITION,
    SET_UNSAVED_DATA,
    SET_USER_ACTION,
    SINGLE_STUDENT_SEARCH_RENDERING,
    TOGGLE_HELPBOX_POPOVER,
    TOGGLE_HIGHLIGHTS,
    TOGGLE_MODAL_DIALOG,
    TOGGLE_STUDENT_LIST_POPOVER,

    changeSelectedSubject: function(
        newSubject,
        updatePreferredSubject = false,
        delayStateUpdateUntilTransitionComplete = false
    ) {
        reactor.dispatch(CHANGE_SELECTED_SUBJECT, {
            newSubject,
            updatePreferredSubject,
            delayStateUpdateUntilTransitionComplete,
        });
    },
    completeTransition: function() {
        reactor.dispatch(COMPLETE_TRANSITION);
    },
    expandModule: function(moduleToExpand, termNumber = null, delayStateUpdateUntilTransitionComplete = false) {
        reactor.dispatch(EXPAND_MODULE, { moduleToExpand, termNumber, delayStateUpdateUntilTransitionComplete });
    },
    toggleHelpboxPopover: function(openHelpBoxId = '', appLevelCssClassName = '') {
        reactor.dispatch(TOGGLE_HELPBOX_POPOVER, { openHelpBoxId, appLevelCssClassName });
    },
    setStudentTransition: function(movingTo = null, userAction = '') {
        reactor.dispatch(SET_STUDENT_TRANSITION, { movingTo, userAction });
    },
    setAnimationIsRunning: function(isRunning) {
        reactor.dispatch(SET_ANIMATION_IS_RUNNING, isRunning);
    },
    advanceToAdjacentStudent: function() {
        reactor.dispatch(ADVANCE_TO_ADJACENT_STUDENT);
    },
    closeGradeDropdown: function() {
        reactor.dispatch(CLOSE_GRADE_DROPDOWN);
    },
    toggleStudentListPopover: function(showStudentList) {
        reactor.dispatch(TOGGLE_STUDENT_LIST_POPOVER, showStudentList);
    },
    clearState: function() {
        reactor.dispatch(CLEAR_STATE);
    },
    selectInstructionalAreas: function(subjectBid, goals) {
        reactor.dispatch(SELECT_INSTRUCTIONAL_AREAS, {
            subject: subjectBid,
            goals,
        });
    },
    selectComparisonPeriod: function(subjectBid, selectedPeriod) {
        reactor.dispatch(SELECT_COMPARISON_PERIOD, {
            subject: subjectBid,
            selectedPeriod,
        });
    },
    setUnsavedData: function(unsavedYn, modifier = null) {
        reactor.dispatch(SET_UNSAVED_DATA, { unsavedYn, modifier });
    },
    setUserAction: function(action = '') {
        reactor.dispatch(SET_USER_ACTION, action);
    },
    registerModal: function(modalName, openModalFunc) {
        reactor.dispatch(REGISTER_MODAL, { modalName, openModalFunc });
    },
    toggleHighlights: function() {
        reactor.dispatch(TOGGLE_HIGHLIGHTS);
    },
    setPageAlert: function(pageAlert) {
        reactor.dispatch(SET_PAGE_ALERT, pageAlert);
    },
    setSingleStudentSearchRendering: function(singleStudentSearchRendering) {
        reactor.dispatch(SINGLE_STUDENT_SEARCH_RENDERING, singleStudentSearchRendering);
    },
    resetDisplaySettingsForSingleStudentSearch: function() {
        reactor.dispatch(RESET_DISPLAY_SETTINGS);
    },
    allowAdvanceStudent: function(isAllowed) {
        reactor.dispatch(ALLOW_ADVANCE_STUDENT, isAllowed);
    },
    initialLoadDone: function(bool) {
        reactor.dispatch(INITIAL_LOAD_DONE, bool);
    },
};
